<template>
    <header class="app-header w-full h-56 left-0 right-0 top-0 z-50 bg-white" :class="[flat || border ? '' : 'shadow', {'fixed': fixed, 'border-b-2': border}]">
        <container class="h-full" :fluid="fluid" xs-full>
            <div class="flex items-center justify-between h-full">
                <div class="flex h-full mr-4 overflow-hidden">
                    <div v-if="!mobileMenu || showDesktopStyle" :style="{width: logoWidthStyle ? logoWidthStyle : '100%'}" class="flex items-center h-full">
                        <nuxt-link to="/" class="flex items-center h-full pl-16 sm:pl-0">
                            <cdn-image v-if="!mobileLogo || showDesktopStyle" :src="logo" :height="logoHeight" :ratio="logoRatio" alt="SPOFERAN" immediate/>
                            <cdn-image v-else :src="mobileLogo" alt="SPOFERAN" :height="26" :ratio="mobileLogoRatio" immediate/>
                        </nuxt-link>
                    </div>
                    <div v-else class="h-full flex items-center justify-center pl-16 sm:pl-0">
                        <menu-btn v-model="isActive"/>
                    </div>
                    <slot name="left_items" v-bind:isDesktop="showDesktopStyle"/>
                </div>

                <slot v-bind:isDesktop="showDesktopStyle"/>

                <div v-if="showDesktopStyle" class="h-full flex items-center">
                    <btn v-for="(navItem, navItemKey) in items" :key="navItemKey" :aria-label="navItem.text ? navItem.text : navItem.alt"
                         :to="navItem.to ? navItem.to : navItem.href" :exact="navItem.exact" :text="!navItem.button" rounded-large
						 :color="navItem.color"
						 active-color="primary">
                        <span v-if="navItem.text">{{ navItem.text }}</span>
                        <Icon v-if="navItem.text_icon" :icon="navItem.text_icon" x-small force-size/>
                    </btn>
                    <slot name="items" v-bind:isDesktop="showDesktopStyle"/>
                </div>
                <div v-else class="h-full flex items-center pr-16 sm:pr-0">
                    <btn v-for="(navItem, navItemKey) in mobileItems" :key="navItemKey" :aria-label="navItem.text ? navItem.text : navItem.alt"
                         :to="navItem.to ? navItem.to : navItem.href" :exact="navItem.exact" :text="!navItem.button" rounded-large
						 :color="navItem.color"
						 active-color="primary">
                        <span v-if="navItem.text">{{ navItem.text }}</span>
                        <Icon v-if="navItem.text_icon" :icon="navItem.text_icon" x-small force-size/>
                    </btn>
                    <slot name="items" v-bind:isDesktop="showDesktopStyle"/>
                </div>
            </div>
        </container>
    </header>
</template>
<script>
import {Images} from "@spoferan/spoferan-ts-core";
import {formatDimension} from "@spoferan/spoferan-ts-core";
import Toggleable from "../../mixins/Toggleable";

export default {

    name: 'AppHeader',

    mixins: [Toggleable],

    props: {

        // The logo source
        logo: {
            type: [String, Object],
            default: Images.logo.path
        },

        // The logo source for mobile devices
        mobileLogo: {
            type: [String, Object, Boolean],
            default: Images.favicon.path
        },

        // The aspect ratio of the logo image
        logoRatio: {
            type: Number,
            default: Images.logo.ratio
        },

        // The height of the logo image
        logoHeight: {
            type: Number,
            default: 26
        },

        // The aspect ratio of the mobile logo image
        mobileLogoRatio: {
            type: Number,
            default: Images.favicon.ratio
        },

        // The width of the logo area
        logoWidth: {
            type: Number,
            default: null
        },

        // The navigation items to show
        items: {
            type: Array,
            default: null
        },

        // The navigation items to show on the mobile layout
        mobileItems: {
            type: Array,
            default: null
        },

        // Whether the navbar is fixed to the top
        fixed: {
            type: Boolean,
            default: false
        },

        // Whether the navbar shall receive a bottom border
        border: {
            type: Boolean,
            default: false
        },

        // Whether the navbar container shall be full width
        fluid: {
            type: Boolean,
            default: false
        },

        // Whether no shadow shall be added
        flat: {
            type: Boolean,
            default: false
        },

        // Whether a clickable menu icon shall be displayed on mobile devices
        mobileMenu: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        logoWidthStyle() {
            return this.logoWidth ? formatDimension(this.logoWidth - 16) : null
        },

        showDesktopStyle() {
            return this.$device.isDesktop;
        }
    }

}
</script>